import { normalizeResumeText } from '@soVendor/utils/pdfTextSanitizer';
import ResumePreviewForPDF from '@modules/single-optimize/aiResumeOptimizer/ResumePreviewForPDF';
import {
  parseResumeSections,
  bucketResumeSections,
  sortSectionsByCanonicalOrder,
  type ResumeSection,
} from '@modules/single-optimize/aiResumeOptimizer/utils/parseResumeSections';
import type { SavedProfileDesign } from '@modules/single-optimize/aiResumeOptimizer/utils/savedProfileResumeFile';

/** Shared with PDF download / preview modal — same parsing as on-screen preview. */
export function buildResumeSectionsFromStoredBody(body: string): ResumeSection[] {
  const normalized = normalizeResumeText(body);
  const raw = parseResumeSections(normalized);
  return sortSectionsByCanonicalOrder(bucketResumeSections(raw).filter((s) => s.content.trim().length > 0));
}

export function SavedOptimizedResumePreview({
  bodyText,
  templateId,
  design,
  className = '',
}: {
  bodyText: string;
  templateId: string;
  design?: SavedProfileDesign;
  /** e.g. max height + scroll for embedded card */
  className?: string;
}) {
  const sections = buildResumeSectionsFromStoredBody(bodyText);

  if (sections.length === 0) {
    return (
      <div className={`rounded-lg border border-gray-800 bg-black/30 p-4 text-xs text-gray-400 ${className}`}>
        (No resume content to preview)
      </div>
    );
  }

  return (
    <div className={`flex justify-center overflow-x-auto ${className}`}>
      <div className="inline-block max-w-full rounded-lg shadow-xl ring-1 ring-gray-700/80">
        <ResumePreviewForPDF sections={sections} templateId={templateId} design={design} />
      </div>
    </div>
  );
}
